import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';

@Component({
  selector: 'app-complete-pattern',
  templateUrl: './complete-pattern.component.html',
  styleUrls: ['./complete-pattern.component.css']
})
export class CompletePatternComponent extends GeneralExerciseComponent {

  // Two types of complete exercise: only complete at the end of the sequence or at random positions in the sequence
  isCompleteEndExercise: boolean;
  isCorrect: boolean; // subexercise correct

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.solved = false;
  }

  checkSolution() {
    if (this.isCorrect) {
      this.isSolvedImageVisible = true;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
      this.messageService.addAlertWithTimeout(this.get('correctlySolved'), 'success', 1000);
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlySolved'), 'danger', 2000);
    }
  }

  generateNextExercise() {
    this.initValues();
    this.counter ++;
  }

  setSolved(isSolved) {
    this.solved = isSolved;
  }

  setCorrect(isCorrect: boolean) {
    this.isCorrect = isCorrect;
    this.checkSolution();
  }

  computeState() {
  }

  setTypeSpecificsFromConfiguration() {
    this.isCompleteEndExercise = this.configuration.typespecifics.isCompleteEndExercise;
  }

  setTypeSpecificsFromState() {
  }
}
